import { useState } from "react";

interface FooterColumn {
  title: string;
  links: { label: string; href: string }[];
}

const columns: FooterColumn[] = [
  {
    title: "关于本站",
    links: [
      { label: "吃瓜说明", href: "#top" },
      { label: "更新节奏", href: "#flash" },
      { label: "内容来源", href: "#collections" },
    ],
  },
  {
    title: "内容索引",
    links: [
      { label: "今日速报", href: "#flash" },
      { label: "话题墙", href: "#topics" },
      { label: "封面专题", href: "#covers" },
      { label: "事件时间线", href: "#timeline" },
    ],
  },
  {
    title: "合集与榜单",
    links: [
      { label: "合集索引", href: "#collections" },
      { label: "现场实拍", href: "#gallery" },
      { label: "热瓜榜单", href: "#ranking" },
    ],
  },
];

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-tv-2-line", label: "短视频" },
  { icon: "ri-mail-line", label: "邮箱" },
];

export default function SiteFooter() {
  const [toast, setToast] = useState(false);

  const handleSave = () => {
    setToast(true);
    window.setTimeout(() => setToast(false), 2200);
  };

  return (
    <footer className="w-full">
      <div className="w-full bg-primary-600 text-background-50">
        <div className="w-full px-4 md:px-6 py-10 md:py-12 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div className="max-w-2xl">
            <h3 className="font-heading text-2xl md:text-3xl font-bold mb-3">想第一时间跟上热瓜节奏？</h3>
            <p className="text-sm md:text-base text-background-100/90 leading-relaxed">
              黑料网吃瓜速览每日加更，把最新现场实拍与事件汇总按时间排好，打开就能顺着看下去。
            </p>
          </div>
          <button
            type="button"
            onClick={handleSave}
            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50 text-primary-700 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
          >
            <i className="ri-bookmark-line text-base"></i>
            收藏本站 · 每日加更
          </button>
        </div>
      </div>

      <div className="w-full bg-background-100 border-t border-background-200">
        <div className="w-full px-4 md:px-6 py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-10">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2.5 mb-4">
                <span className="w-9 h-9 rounded-md flex items-center justify-center bg-primary-500 text-background-50 font-heading text-lg font-bold">
                  瓜
                </span>
                <span className="font-heading text-xl font-bold text-foreground-950">黑料网吃瓜</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
                把黑料网吃瓜现场、吃瓜事件与吃瓜合集放在同一个页面里，按时间线持续汇总，顺手吃瓜不掉队。
              </p>
              <div className="flex items-center gap-2.5 mt-6">
                {socials.map((s) => (
                  <button
                    key={s.label}
                    type="button"
                    aria-label={s.label}
                    className="w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 cursor-pointer hover:bg-secondary-100 hover:text-secondary-900 hover:border-secondary-300 transition-colors"
                  >
                    <i className={`${s.icon} text-lg`}></i>
                  </button>
                ))}
              </div>
            </div>

            {columns.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-base font-bold text-foreground-950 mb-4">{col.title}</h4>
                <ul className="flex flex-col gap-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-foreground-600 cursor-pointer hover:text-primary-600 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <p className="text-xs text-foreground-500">© 2026 黑料网吃瓜 · 内容为资讯整理，仅供浏览参考</p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span className="cursor-pointer hover:text-primary-600 transition-colors">免责声明</span>
              <span className="cursor-pointer hover:text-primary-600 transition-colors">内容反馈</span>
              <a href="#top" className="inline-flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                <i className="ri-arrow-up-line"></i>
                回到顶部
              </a>
            </div>
          </div>
        </div>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[60] px-5 py-3 rounded-md bg-foreground-950 text-background-50 text-sm whitespace-nowrap">
          已加入你的吃瓜清单（演示效果）
        </div>
      )}
    </footer>
  );
}